<template>
  <div class="header">
    <h1>JYG ESG 企業健檢 - 聯絡資訊</h1>
  </div>
  <div
    v-for="item in userInfo"
    :key="item"
    class="position-relative d-flex align-items-center justify-content-between pt-4 col-12"
  >
    <span class="text-nowrap col-1 text-center">{{ item.label }}</span>
    <input
      disabled
      class="rounded-pill border info col-11"
      v-model="item.value"
      :placeholder="item.placeholder"
    />
  </div>

  <div
    class="position-relative d-flex align-items-center justify-content-between pt-4 pb-5 col-12"
  >
    <span class="text-nowrap col-1 text-center">聯絡狀態</span>
    <select v-model="state" class="rounded-pill info col-11 border">
      <option
        v-for="option in options"
        :value="option.value"
        :key="option.value"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
  <div class="col-12 d-flex align-items-center justify-content-center">
    <button
      v-if="!getUserId"
      @click="$router.push(`/user-management/create-user/${$route.params.id}`)"
      class="btn btn-outline-primary user-btn rounded-pill col-3 ms-2"
    >
      新增用戶
    </button>
    <button
      @click="submit"
      class="btn btn-outline-primary user-btn rounded-pill col-3 ms-2"
    >
      完成
    </button>
  </div>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import { ref } from '@vue/reactivity'
import MsgBox from '@/components/MsgBox.vue'
import { useRoute } from 'vue-router'
import useQuestionnaire from '@/composables/useQuestionnaire'
import { computed } from '@vue/runtime-core'
export default {
  components: {
    MsgBox,
  },
  setup() {
    const route = useRoute()
    const { getFormList, editFormList } = useQuestionnaire()
    const formList = ref([])
    const options = ref([
      { text: '未聯絡', value: '0' },
      { text: '聯絡中', value: '1' },
      { text: '已簽約', value: '2' },
      { text: '已拒絕', value: '3' },
    ])
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const state = ref('0')
    const getList = async () => {
      const res = await getFormList()
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        formList.value = res.ret['form-list']
      }
    }
    getList()
    const getInfo = computed(() => {
      return formList.value.find((e) => {
        return e.id === +route.params.id
      })
    })
    const getUserId = computed(() => {
      return getInfo.value?.user_id
    })
    const userInfo = computed(() => {
      return [
        {
          label: '姓名',
          value: getInfo.value?.name,
        },

        {
          label: '電子郵件',
          value: getInfo.value?.email,
        },
        {
          label: '聯絡電話',
          value: getInfo.value?.company_phone,
        },
      ]
    })
    const submit = async () => {
      const res = await editFormList({
        id: route.params.id,
        contact_status: state.value,
      })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        showMsgBox.value = true
        errorCode.value = 'userStateSuccess'
        errorMsg.value = '狀態更改成功'
      }
    }
    return {
      userInfo,
      errorCode,
      options,
      showMsgBox,
      submit,
      errorMsg,
      state,
      formList,
      getInfo,
      getUserId,
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
.user-img {
  width: 160px;
  height: 160px;
  border: 1px #eff0f6 solid;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 64px auto 16px;
}
.info {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
}
input::placeholder {
  font-size: 16px;
}
select {
  background: url('~@/assets/icons/arrow-down.svg') no-repeat scroll 97% center
    transparent;
  appearance: none;
  color: #4d4d4d;
}

.copy {
  right: 32px;
}

.user-btn {
  height: 48px;
  margin: 24px 0 72px 0;
}
</style>
